import React from 'react';

import ModifyButton from 'components/atoms/Button/ModifyButton';

import './index.scss';

const PcConfOdItem = ({ text, children, changeModifyMode }) => {
  return (
    <div className="PcConfOdItem">
      <span className="tagArea">
        <label className="tag">{text}</label>
      </span>
      <span className="items">
        {children}
      </span>
      <span className="modify-button-area">
        <span className="">
          <ModifyButton onClick={changeModifyMode} />
        </span>
      </span>
    </div>
  );
};

export default PcConfOdItem;